import React, { memo } from 'react';
import { Section } from './ui/Section';
export function ValueCalculator() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  return <Section data-id="element-354">
      <div className="max-w-2xl mx-auto" data-id="element-355">
        <div className="bg-white border border-brand-border rounded-2xl p-8 mb-8 shadow-card" data-id="element-356">
          <div className="space-y-6 text-center" data-id="element-357">
            <p className="text-lg text-brand-text leading-relaxed" data-id="element-358">
              Cada semana que pasa sin un sistema es otra semana improvisando.
            </p>
            <p className="text-lg text-brand-text leading-relaxed" data-id="element-359">
              Tus alumnas no ven todo el trabajo que haces detrás.
            </p>
            <p className="text-lg text-brand-text leading-relaxed" data-id="element-360">
              Solo perciben el resultado.
            </p>
            <p className="text-2xl text-brand-title font-bold font-display" data-id="element-361">
              Haz que cada clase parezca profesional, organizada y memorable
              desde hoy.
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-362">
          <button onClick={scrollToPricing} className="bg-gradient-gold hover:bg-brand-ctaHover text-white font-bold text-xl md:text-2xl py-5 px-10 rounded-2xl transition-colors w-full md:w-auto tracking-wide shadow-gold-glow" data-id="element-363">
            🚀 QUIERO EL SISTEMA COMPLETO
          </button>
          <div className="mt-4 flex items-center justify-center gap-3 text-xs text-brand-textMuted flex-wrap" data-id="element-364">
            <span data-id="element-365">⚡ Acceso Inmediato</span>
            <span data-id="element-366">·</span>
            <span data-id="element-367">💳 Pago Único</span>
            <span data-id="element-368">·</span>
            <span data-id="element-369">🛡️ 7 Días</span>
            <span data-id="element-370">·</span>
            <span data-id="element-371">📱 PDF Móvil</span>
          </div>
        </div>
      </div>
    </Section>;
}